module.exports = __webpack_public_path__ + "static/media/la-solid-900.87292218.woff";